export default __webpack_public_path__ + "static/media/indeterminate-check-box-icon-orange.cd3daffa.svg";